import "./libs/slick.min.js";
//import './libs/mediaelement-and-player.js';
import {binder} from "./libs/binder";
import {main} from "./modules/main";
import {popups} from "./modules/popups";
import {sliders} from "./modules/sliders";
import { accordion } from "./modules/accordion";

binder({
	bounds: {
		html: [main, popups, sliders],
		'.section-accordion': accordion,
	},
	runTests: false,
})


// WEBPACK FOOTER //
// ./assets/js/global.js